var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSavingMoneyFlower = function SvgSavingMoneyFlower(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4258 17.5312V31.9688",
    stroke: "url(#paint0_linear_666_52)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4255 31.9687C16.4255 31.9687 14.8717 27.7186 7.75195 23.188",
    stroke: "url(#paint1_linear_666_52)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.03377 26.125C6.44452 27.6595 8.66652 28.2191 10.0154 25.3495C13.3525 23.375 11.9844 20.8752 10.0883 19.5662C8.68741 18.8835 7.14548 18.5401 5.58728 18.564C4.02909 18.5879 2.49841 18.9784 1.11914 19.7037C3.39614 21.9106 3.27927 24.2124 5.03377 26.125Z",
    stroke: "url(#paint2_linear_666_52)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4258 31.9687C16.4258 31.9687 17.9795 27.7186 25.1007 23.188",
    stroke: "url(#paint3_linear_666_52)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8175 26.125C26.4081 27.6595 24.1847 28.2191 22.8372 25.3495C19.5001 23.3722 20.8682 20.8739 22.763 19.5649C24.1641 18.8822 25.7063 18.5389 27.2647 18.5628C28.8231 18.5867 30.3539 18.9771 31.7335 19.7024C29.4551 21.9106 29.5734 24.2124 27.8175 26.125Z",
    stroke: "url(#paint4_linear_666_52)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4879 5.15626H15.6925C15.2632 5.15489 14.8469 5.30338 14.5153 5.5761C14.1838 5.84883 13.9577 6.22871 13.8763 6.65023C13.7948 7.07174 13.863 7.50848 14.069 7.88511C14.2751 8.26175 14.6061 8.55468 15.005 8.71338L17.8416 9.84913C18.2391 10.009 18.5685 10.3023 18.7734 10.6785C18.9783 11.0547 19.0459 11.4905 18.9646 11.9112C18.8833 12.3318 18.6582 12.711 18.3278 12.9838C17.9975 13.2566 17.5826 13.406 17.1541 13.4063H14.3629",
    stroke: "url(#paint5_linear_666_52)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4258 5.15625V4.125",
    stroke: "url(#paint6_linear_666_52)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4258 14.4375V13.4062",
    stroke: "url(#paint7_linear_666_52)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.17578 9.28125C8.17578 11.4693 9.04497 13.5677 10.5921 15.1149C12.1393 16.6621 14.2377 17.5312 16.4258 17.5312C18.6138 17.5312 20.7122 16.6621 22.2594 15.1149C23.8066 13.5677 24.6758 11.4693 24.6758 9.28125C24.6758 7.09321 23.8066 4.99479 22.2594 3.44762C20.7122 1.90044 18.6138 1.03125 16.4258 1.03125C14.2377 1.03125 12.1393 1.90044 10.5921 3.44762C9.04497 4.99479 8.17578 7.09321 8.17578 9.28125V9.28125Z",
    stroke: "url(#paint8_linear_666_52)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_666_52",
    x1: 17.4258,
    y1: 24.8646,
    x2: 16.4258,
    y2: 24.8646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DD3C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C5F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_666_52",
    x1: 16.4255,
    y1: 27.6481,
    x2: 7.75195,
    y2: 27.6481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DD3C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C5F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_666_52",
    x1: 12.0434,
    y1: 23.0464,
    x2: 1.11914,
    y2: 23.0464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DD3C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C5F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_666_52",
    x1: 25.1007,
    y1: 27.6481,
    x2: 16.4258,
    y2: 27.6481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DD3C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C5F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_666_52",
    x1: 31.7335,
    y1: 23.0458,
    x2: 20.8091,
    y2: 23.0458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DD3C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C5F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_666_52",
    x1: 18.9981,
    y1: 9.34673,
    x2: 13.8428,
    y2: 9.34673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DD3C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C5F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_666_52",
    x1: 17.4258,
    y1: 4.64881,
    x2: 16.4258,
    y2: 4.64881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DD3C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C5F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_666_52",
    x1: 17.4258,
    y1: 13.9301,
    x2: 16.4258,
    y2: 13.9301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DD3C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C5F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_666_52",
    x1: 24.6758,
    y1: 9.4122,
    x2: 8.17578,
    y2: 9.4122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DD3C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C5F1"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSavingMoneyFlower);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,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";